<template>
  <base-material-card
    color="primary"
    icon="mdi-finance"
    inline
    class="px-5 py-4 ml-0"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        Índice IPCA
      </div>
    </template>
    <v-btn
      id="btn-novo-indice-ipca"
      class="new-ipca-btn mt-5"
      color="success"
      dark
      elevation="1"
      style="float:left"
      relative
      text
      medium
      :loading="loadingDelete"
      @click="$router.push('edit')"
    >
      <v-icon left size="30px">
        mdi-plus-circle
      </v-icon>
      Novo Índice IPCA
    </v-btn>
    <v-btn
      id="btn-novo-indice-ipca-estimado"
      class="mt-5 break-search new-ipca-estimado-btn"
      color="success"
      dark
      elevation="1"
      relative
      text
      medium
      :loading="loadingDelete"
      @click="$router.push('edit-ipca-estimado')"
    >
      <v-icon left size="30px">
        mdi-plus-circle
      </v-icon>
      Novo Índice IPCA Estimado
    </v-btn>
    <v-text-field
      id="indie-icpca-search"
      v-model="search"
      append-icon="mdi-magnify"
      class="ml-auto mt-4 break-search search-rs-ipca"
      label="Procurar"
      hide-details
      single-line
    />
    <v-divider class="mt-10" />
    <v-data-table
      :class="checkBoxDeletes.length ? 'table-ipca' : ''"
      :headers="headers"
      :items="items"
      :search.sync="search"
      :headerProps="{
        sortByText: 'Ordenar Por'
      }"
      :footer-props="{
        itemsPerPageText: 'Itens por Página'
      }"
      :mobile-breakpoint="800"
      loading-text="Carregando..."
      no-data-text="Nenhum indice IPCA encontrado"
      no-results-text="Nenhum registro correspondente encontrado"
    > 
      <template v-slot:item="row">
        <v-tooltip
          bottom
          :disabled="row.item.IndiceOficial == 'Sim'"
        >
          <template v-slot:activator="{ on, attrs }">
            <tr
              :class="row.item.IndiceOficial == 'Não' ? 'atualizacao-indices-table-tr' : ''"
              v-bind="attrs"
              v-on="on"
            >
              <td class="text-start">
                <v-checkbox
                  v-model="checkAUX[`${row.item.DataRegistro}_${row.item.IndiceOficial}`]"
                  class="mt-0 mb-n5"
                  :disabled="loadingDelete"
                  @change="managerCheckBoxDeletes(row.item, $event)"
                />
              </td>
              <td class="text-start">
                {{ row.item.DataRegistro | formatToMonth }}
              </td>
              <td class="text-start">
                {{ row.item.VariacaoMes | parseNumberToFloatBR }}
              </td>
              <td class="text-start">
                {{ row.item.IndiceMes | parseNumberToFloatBR }}
              </td>
              <td class="text-start">
                {{ row.item.IndiceOficial }}
              </td>
              <td class="text-center">
                <template v-if="[ultimoRegistroOficial, ultimoRegistroNaoOficial].includes(row.item.DataRegistro)">
                  <v-btn
                    id="btn-edit-indice-ipca"
                    class="px-1"
                    min-width="0"
                    fab
                    icon
                    x-small
                    :disabled="loadingDelete"
                    @click="
                      $router.push(row.item.IndiceOficial == 'Sim' ? `edit/${row.item.DataRegistro}` : `edit-ipca-estimado/${row.item.DataRegistro}`)
                    "
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="(ultimoRegistroNaoOficial == '' && ultimoRegistroOficial == row.item.DataRegistro) || ultimoRegistroNaoOficial == row.item.DataRegistro"
                    id="btn-excluir-indice-ipca"
                    class="px-1"
                    min-width="0"
                    fab
                    icon
                    x-small
                    :loading="loadingDelete"
                    @click="openDialogDelete(row.item)"
                  >
                    <v-icon small>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <small v-else>-</small>
              </td>
            </tr>
          </template>
            <span >
              Esse Índice de IPCA é um valor estimado futuro, não é um valor oficial
            </span>
        </v-tooltip>
      </template>
      <template v-slot:[`footer.page-text`]>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
          </template>
          <span>Clique aqui para recarregar os índices</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <template v-if="checkBoxDeletes.length">
      <v-btn
        color="primary"
        dark
        elevation="1"
        relative
        text
        small
        :loading="loadingDelete"
        @click="openDialogDeleteMultiplos()"
      >
        <v-icon left size="18px">
          mdi-trash-can-outline
        </v-icon>
        Excluir Multiplos
      </v-btn>
    </template>
    <dialog-delete 
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="managerDeletes()"
    >
      <template slot="title">
        <template v-if="JSON.stringify(dialogDeleteData) !== '{}'">
          Deletar Índice IPCA
        </template>
        <template v-else>
          Deletar Múltiplos Índices IPCA
        </template>
      </template>
      <template slot="body">
        <template v-if="JSON.stringify(dialogDeleteData) !== '{}'">
          Tem certeza que deseja deletar o índice IPCA do mês <strong>{{ dialogDeleteData.DataRegistro | formatToMonth }}</strong>?
        </template>
        <template v-else>
          Tem certeza que deseja deletar todos índices de IPCA marcados?
        </template>
      </template>
    </dialog-delete>
  </base-material-card>
</template>
  
<script>
import AtualizacaoIndicesService from '@/services/AtualizacaoIndicesService';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
import dayjs from 'dayjs';

export default {
  mixins: [powerupsActionsMixins],

  props: {
    items: {
      type: Array,
      default: () => []
    },
    ultimoRegistroOficial: {
      type: String,
      default: () => ''
    },
    ultimoRegistroNaoOficial: {
      type: String,
      default: () => ''
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete')
  },

  data: () => ({
    powerupService: AtualizacaoIndicesService,
    powerupEntityName: "Atualização de Índices",
    search: '',
    headers: [
      {
        sortable: false
      },
      {
        text: 'Mês de Referência',
        value: 'DataRegistro'
      },
      {
        text: 'Variação no Mês',
        value: 'VariacaoMes'
      },
      {
        text: 'Índice no Mês',
        value: 'IndiceMes'
      },
      {
        text: 'Índice Oficial',
        value: 'IndiceOficial'
      },
      {
        sortable: false,
        text: 'Ações',
        value: 'actions',
        align: 'center',
      }
    ],
    checkAUX: [], /* Variavel auxiliar apenas para exibir se os check-box estão marcados */
    checkBoxDeletes: [],
    loadingDelete: false
  }),

  methods: {
    managerDeletes() {
      if (JSON.stringify(this.dialogDeleteData) !== '{}') {
        this.deletarItem(this.dialogDeleteData);
      } else {
        this.excluirMultiplosIds(this.checkBoxDeletes);
      }
    },

    managerCheckBoxDeletes(indice, condiction) {
      let indicePARAM = {'DataRegistro': indice.DataRegistro, 'IndiceOficial': indice.IndiceOficial};

      if (condiction) this.checkBoxDeletes.push(indicePARAM);
      if (!condiction) this.checkBoxDeletes = this.checkBoxDeletes.filter(indice => JSON.stringify(indice) !== JSON.stringify(indicePARAM));
    },

    openDialogDeleteMultiplos() {
      let modalLiberado = this.checkIntervalosMesesMarcados();
      
      if (modalLiberado) {
        this.dialogDeleteData = {};
        this.dialogDelete = true;
      }
    },

    openDialogDelete(indice) {
      this.dialogDeleteData = indice;
      this.dialogDelete = true;
    },

    deletarItem(indice, eventName = "rechargeTable") {
      this.loadingDelete = true;
      this.dialogDelete = false;

      this.powerupService.deletar(indice.DataRegistro)
        .then(() => {
          this.$toast.success(`${this.powerupEntityName} removido(a) com sucesso.`, '', {position:'topRight'});
          this.$emit(eventName);
        })
        .catch(error => {
          this.$toast.error(`Erro ao deletar ${this.powerupEntityName}.`, '', {position:'topRight'});
          console.error(error);
        })
        .finally(() => this.loadingDelete = false)
    },

    checkIntervalosMesesMarcados() {
      let itensMarcados = [];
      let itensNaoMarcados = [];
      
      this.items.forEach(item => {
        let indiceEncontrado = (this.checkBoxDeletes.find(checkBoxItem => checkBoxItem.DataRegistro == item.DataRegistro && checkBoxItem.IndiceOficial == item.IndiceOficial)) ? true : false;
        indiceEncontrado ? itensMarcados.push(item) : itensNaoMarcados.push(item);
      });

      itensMarcados = itensMarcados.sort((a, b) => a.DataRegistro > b.DataRegistro ? 1 : -1);
      itensNaoMarcados = itensNaoMarcados.sort((a, b) => a.DataRegistro > b.DataRegistro ? 1 : -1);

      let ultimoRegistro = this.ultimoRegistroNaoOficial || this.ultimoRegistroOficial;
      let lacunaEntreDatasEncontrada = false;
      let ultimoRegistroMarcado = false;
      itensMarcados.forEach((item, i) => {
        if (item.DataRegistro == ultimoRegistro) ultimoRegistroMarcado = true;
        if (!itensMarcados[i-1]) return 'continue';

        let dataMesAtual = dayjs(item.DataRegistro);
        let dataEsperadaMesAtual = (dayjs(itensMarcados[i-1].DataRegistro)).add(1, 'month');
        /* Verifica se a "Data do Mẽs Atual" é diferente da "Data Esperada Para o Mẽs Atual"" */
        if (!dataMesAtual.isSame(dataEsperadaMesAtual)) lacunaEntreDatasEncontrada = true;
      });

      if (!ultimoRegistroMarcado) {
        ultimoRegistro = dayjs(ultimoRegistro).format('MM/YYYY');
        // this.$toast.warning(`Não é possível excluir os índices de IPCA, pois o mês de referência ${ultimoRegistro} não foi marcado.`, '', {position:'topRight'});
        this.$toast.warning('Não é possível excluir os índices de IPCA, pois existem lacunas entre os meses de referências.', '', {position:'topRight'});
        return false;
      } else if (lacunaEntreDatasEncontrada) {
        this.$toast.warning('Não é possível excluir os índices de IPCA, pois existem lacunas entre os meses de referências.', '', {position:'topRight'});
        return false;
      }

      return true;
    },

    excluirMultiplosIds(arrayIndices) {
      this.loadingDelete = true;
      this.dialogDelete = false;

      this.powerupService.deletarMultiplos(arrayIndices)
      .then(() => {
        this.$toast.success('Índices removidos com sucesso.', '', {position:'topRight'});
        this.checkBoxDeletes = [];
        this.checkAUX = [];
        this.$emit('rechargeTable');
      })
      .catch(() => {
        this.$toast.error('Erro ao deletar Índices', '', { position: 'topRight' });
      })
      .finally(() => this.loadingDelete = false);
    }
  }
}
</script>

<style>
.atualizacao-indices-table-tr { /* background-color: #b3ccdd; */
  background-color: #ffc9c9;
}

@media screen and (max-width: 575px) {
  .new-ipca-estimado-btn,
  .new-ipca-btn {
    float: none !important;
    width: 100% !important;
    margin-left: 0 !important;
  }
  .search-rs-ipca {
    max-width: 100% !important;
  }
}

@media screen and (min-width: 575px) {
  .new-ipca-estimado-btn{
    float: left;
    margin-left: 12px !important;
  }
  .search-rs-ipca {
    max-width: 250px !important;
  }
  .table-ipca {
    margin-bottom: -25px !important;
  }
}
</style>